module.exports = __webpack_public_path__ + "static/media/listazap.ae4c6f8a.svg";